import { useMutation } from '@tanstack/react-query';

import { ChatRequest, ChatResponse, sendChatMessage } from '~/services/AIChatService';

export function useSendChatMessage() {
  return useMutation<ChatResponse, Error, ChatRequest>({
    mutationFn: sendChatMessage,
  });
}
